export enum ChargeLimitPer {
    Visit = 1,
    Episode = 2,
    Contract = 3
}
